module.exports = __webpack_public_path__ + "static/media/endeavour-energy.fb76af86.png";